import { Box, Typography } from "@mui/material";
import React from "react";

const Error = () => {
  return (
    <Box sx={{ width: "100%", textAlign: "center", mt: 10 }}>
      <Typography variant="h2"> 404 - Page not found</Typography>
    </Box>
  );
};

export default Error;
